<div class="sidebar">
  <img src="assets/images/logo.svg" alt="Logo" />
  <!-- <div class="search">
    <app-search-field></app-search-field>
  </div> -->
  <nav>
    @for (item of navItems; track $index) {
      <h6>{{ item.text }}</h6>
      <ul>
        @for (button of item.items; track button) {
          <li
            [routerLink]="button.route"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <fa-icon [icon]="['fas', button.icon]" size="lg"></fa-icon>
            <span>{{ button.text }}</span>
          </li>
        }
      </ul>
    }
  </nav>
</div>
